import $ from "jquery";

// Die Funktion gilt aktuell nur für Relounge
// Code kümmert sich um einfache Modals
let novaModal = $("[data-warenkorb-modal]");

// Muss geprüft werden da Fancybox trotzem intern in einen Fehler läuft aber diesen nicht throwt
// Zum Anschauen das error event hinzufügen und drauf abhören
if (novaModal.length) {
	novaModal.fancybox({
		// @ts-ignore Typedefs kennen die Prop nicht, macht aber auch nix kaputt
		scrollOutside: "false",
		closeClick: false,

		autoFocus: false,
		keyboard: true,
		touch: false,
		toolbar: false,
		smallBtn: true,
		btnTpl: {
			smallBtn: `<button id="fancybox-data-closebutton" data-fancybox-close class="button--close-light"></button>`,
		},
		afterShow: (instance, _current) => {
			$("#fancybox-data-closebutton").prop("title", instance.$trigger!.data("closetext"));
		},
	});
}
